import React, { Component } from "react";

// import "../assets/css/logs.css";
import "../assets/css/info-styles.css";

class InfoDropdown extends Component {
  constructor(props) {
    super(props);

    this.state = {
      ...props,
    };
  }

  render() {
    return (
      <div
        className={"info-container " + (this.props.infoHidden ? "hide" : "")}
      >
        <div className="info-header-row">
          <div className="info-header-item">
            <span>HOW IT WORKS</span>
          </div>

        </div>
        <div className="info-items">
       
            <p className="paragraphs">
              =&gt; On the Inspection environment, input your flight inspection time, and click on START button. NOTE: The highest hours you can set is 1000 (One Thousand), while the minutes and seconds inputs can take maximum (59).
            </p>
            
            <p className="paragraphs">
            =&gt; Whenever you start, pause, tries to reset log, or tries to reset countdown, the current date &amp; time on your device is logged along the countdown timer. Green colour log represents a start-log while the red color represents the remaining activities.
            </p>
          
          <p className="paragraphs">
            =&gt; The RESET button resets the whole time to default, i.e 00:00:00, which of course, stops the countdown timer.
            </p>
            <p className="paragraphs">
            =&gt; The SHOW LOGS/HIDE LOGS button does what their labels indicate. They toggle a Logs Table.
            </p>
            <p className="paragraphs">
=&gt; An alert dialog pops up when your inspection time is remaining five hours. It keeps blinking until you close it.
            </p>
 

   
        </div>

 
      </div>
    );
  }
}

export default InfoDropdown;
